const getSlideTranslate = _ref => {
  let {
    visualOffset,
    alignment,
    visibleSlidesCount,
    extraPixels
  } = _ref;
  const relativeX = 100 * -visualOffset;
  if (alignment === 'left' || extraPixels === 0 || visibleSlidesCount === 0) {
    return `${relativeX}%`;
  }

  // Extra space is added to right align slides at the end of navigation
  if (alignment === 'right') {
    return `calc(${relativeX}% + ${extraPixels}px)`;
  }

  // Extra space is devided by two to center slides while navigation is somewhere
  // in the middle
  if (alignment === 'center') {
    return `calc(${relativeX}% + ${extraPixels / 2}px)`;
  }
  throw new Error('Alignment should be set to left, center, or right');
};
export default getSlideTranslate;